import React from 'react'
import '../courses.css'
import Menubar from '../../home/menubar/Menubar'
import Address from '../../home/footer/Address'
import Carousel from '../../home/carousel/Carousel'
import { htmlimg, htmlData, html_gif } from '../../home/data'
import Hower from '../../home/hower/Hower'
import Typewriter from '../../home/lazy loader/Typewriter'
import ScrollToTopProgress from '../../home/header/ScrollToTopProgress'
import Header from '../../home/header/Header'

function Frontendhtml() {
  const imgUrl = htmlimg;
  const txt = htmlData;
  const gif = html_gif;
  return (
    <div>
        <Header/>
        <Menubar/>
        <Carousel imgUrl={imgUrl}/>
        <Hower gif={gif}/>
        <Typewriter txt={txt}/>

        
        <div className='pannel-container'>
          <div className="accordion accordion-flush" id="accordionFlushExample">
  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-headingOne">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
        <p className='panel-title'>HTML Level-1</p>
      </button>
    </h2>
    <div id="flush-collapseOne" className="accordion-collapse collapse show" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">
        <ul className='uno-li'>
            <li className='list'>What is Html ?</li>
            <li className='list'>OVERVIEW</li>
            <li className='list'>BASIC TAGS</li>
            <li className='list'>ELEMENTS</li>
            <li className='list'>ATTRIBUTES</li>
            <li className='list'>FORMATTING</li>
            <li className='list'>PHRASE TAGS</li>
            <li className='list'>META TAGS</li>
            <li className='list'>COMMENTS</li>
            <li className='list'>IMAGES</li>
            <li className='list'>TABLES</li>
        </ul>
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-headingTwo">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
      <p className='panel-title'>HTML Level-2</p>
      </button>
    </h2>
    <div id="flush-collapseTwo" className="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">
        <ul className='uno-li'>
          	<li className='list'>LISTS</li>
            <li className='list'>TEXT LINKS</li>
            <li className='list'>IMAGE LINKS</li>
            <li className='list'>EMAIL LINKS</li>
            <li className='list'>FRAMES</li>
            <li className='list'>IFRAMES</li>
            <li className='list'>BLOCKS</li>
            <li className='list'>BACKGROUNDS</li>
            <li className='list'>COLORS</li>
            <li className='list'>FONTS</li>
        </ul>
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-headingThree">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
        <p className='panel-title'>HTML Level-3</p>
      </button>
    </h2>
    <div id="flush-collapseThree" className="accordion-collapse collapse" aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">
        <ul className='uno-li'>
          <li className='list'>FORMS</li>
          <li className='list'>EMBED MULTIMEDIA</li>
          <li className='list'>MARQUEES</li>
          <li className='list'>HEADER</li>
          <li className='list'>STYLE SHEET</li>
          <li className='list'>JAVASCRIPT</li>
          <li className='list'>LAYOUTS</li>
          <li className='list'>TAG REFERENCE</li>
          <li className='list'>ATTRIBUTE REFERENCE</li>
          <li className='list'>HTML EVENTS REFERENCE</li>
        </ul>
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-headingFour">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFour" aria-expanded="false" aria-controls="flush-collapseFour">
        <p className='panel-title'>HTML Level-4</p>
      </button>
    </h2>
    <div id="flush-collapseFour" className="accordion-collapse collapse" aria-labelledby="flush-headingFour" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">
        <ul className='uno-li'>
          <li className='list'>FONTS REFERENCE</li>
          <li className='list'>ASCII TABLE LOOKUP</li>
          <li className='list'>COLOR NAMES</li>
          <li className='list'>ENTITIES</li>
          <li className='list'>MIME MEDIA TYPES</li>
          <li className='list'>URL ENCODING</li>
          <li className='list'>LANGUAGE ISO CODES</li>
          <li className='list'>CHARACTER ENCODINGS</li>
          <li className='list'>DEPRECATED TAGS</li>
          <li className='list'>FONTS</li>
        </ul>
      </div>
    </div>
  </div>
          </div>
        </div>

        <div className="table-header">
	<h4><u><b>COURSE DETAILS :</b></u></h4>
<table className="table">
  <thead>
	<tr className="heading">
	<th colSpan="2" className="heading">HTML</th>
	</tr>
  </thead>
<tbody>
<tr>
	<th>About</th>
	<td>HTML stands for Hyper Text Markup Language, which is the most widely used language on Web to develop web pages.HTML was created by Berners-Lee in late 1991 but "HTML 2.0" was the first standard HTML specification which was published in 1995. HTML 4.01 was a major version of HTML and it was published in late 1999. Though HTML 4.01 version is widely used but currently we are having HTML-5 version which is an extension to HTML 4.01, and this version was published in 2012.</td>
</tr>
<tr>
	<th>Audience</th>
	<td>This tutorial is designed for the aspiring Web Designers and Developers with a need to understand the HTML in enough detail along with its simple overview, and practical examples. This tutorial will give you enough ingredients to start with HTML from where you can take yourself at higher level of expertise.</td>
</tr>
</tbody>
</table>
</div>

        <Address/>
        <ScrollToTopProgress/>
    </div>
  )
}

export default Frontendhtml